
import MainComponent from "components/Main";
import Button from "components/Button";

import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';

export default class ToggleButtons extends MainComponent {
    static propTypes = {
        labels: PropTypes.array,
        values: PropTypes.array,
    };
    static defaultProps = {
        labels: [],
        values: [],
        value: null,
    };

    render() {
        const { labels, values, value } = this.props;

        return (
            <div className="toggleButtons flex centerV gap8 rad8">
                {
                    labels.map((label, i) => {
                        const val = values[i];
                        const active = value === val;

                        return (
                            <Button
                                key={i}
                                type={"transparent"}
                                size={"small"}
                                label={label}
                                active={active}
                                onClick={active ? null : this.props.onChange.bind(null, val)}
                            />
                        );
                    })
                }
            </div>
        );
    }
}
